import './Membership.css';

function Membership() {
  return (
    <div className="membership-page">
      <header className="page-header">
        <h1 className="page-title">会员权益</h1>
      </header>

      <main className="page-content">
        {/* 门店信息 */}
        <section className="section store-section">
          <h2 className="section-title">门店信息</h2>
          <div className="store-card">
            <img src="/5.jpg" alt="门店图片" className="store-image" />
            <div className="store-info">
              <span className="store-name">趣炼游戏健身</span>
              <span className="store-address">地址：成都市武侯区来凤四路151号</span>
            </div>
          </div>
        </section>

        {/* 会员权益 */}
        <section className="section">
          <h2 className="section-title">会员权益</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <span className="benefit-icon">1</span>
              <div className="benefit-content">
                <span className="benefit-title">全场器械使用</span>
                <span className="benefit-desc">会员有效期内全场器械免费使用</span>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">2</span>
              <div className="benefit-content">
                <span className="benefit-title">私教指导</span>
                <span className="benefit-desc">专业私教一对一指导，助您科学健身</span>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">3</span>
              <div className="benefit-content">
                <span className="benefit-title">淋浴更衣</span>
                <span className="benefit-desc">独立淋浴间、更衣室，干净舒适</span>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">4</span>
              <div className="benefit-content">
                <span className="benefit-title">拍档服务</span>
                <span className="benefit-desc">智能设备辅助训练，教练实时指导</span>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">5</span>
              <div className="benefit-content">
                <span className="benefit-title">训练记录</span>
                <span className="benefit-desc">详细记录每次训练数据，科学追踪进步</span>
              </div>
            </div>
          </div>
        </section>

        {/* 连续包月说明 */}
        <section className="section">
          <h2 className="section-title">连续包月说明</h2>
          <div className="info-card">
            <div className="info-row">
              <span className="info-label">自动续费</span>
              <span className="info-value">每月自动扣款，无需手动续费</span>
            </div>
            <div className="info-row">
              <span className="info-label">随时取消</span>
              <span className="info-value">可随时取消，取消后到期自动停止</span>
            </div>
            <div className="info-row">
              <span className="info-label">退订方式</span>
              <span className="info-value">微信内：我 → 服务 → 支付 → 右上角··· → 扣费服务 → 取消</span>
            </div>
          </div>
        </section>

        {/* 价目表 */}
        <section className="section">
          <h2 className="section-title">价目表</h2>
          <div className="price-table">
            <div className="price-header">
              <span className="col-name">卡种</span>
              <span className="col-price">单价</span>
              <span className="col-monthly">包月价</span>
            </div>
            <div className="price-row">
              <span className="col-name">月卡</span>
              <span className="col-price">¥240</span>
              <span className="col-monthly">¥139/月</span>
            </div>
          </div>
          <span className="price-note">* 包月价为连续自动续费价格，随时可取消</span>
        </section>

        {/* 退订指引 */}
        <section className="section">
          <h2 className="section-title">如何取消自动续费</h2>
          <div className="guide-steps">
            <div className="step-item">
              <span className="step-num">1</span>
              <span className="step-text">打开微信，点击右下角「我」</span>
            </div>
            <div className="step-item">
              <span className="step-num">2</span>
              <span className="step-text">点击「服务」</span>
            </div>
            <div className="step-item">
              <span className="step-num">3</span>
              <span className="step-text">点击「支付」</span>
            </div>
            <div className="step-item">
              <span className="step-num">4</span>
              <span className="step-text">点击右上角「···」</span>
            </div>
            <div className="step-item">
              <span className="step-num">5</span>
              <span className="step-text">点击「扣费服务」</span>
            </div>
            <div className="step-item">
              <span className="step-num">6</span>
              <span className="step-text">找到「趣炼健身」点击「关闭服务」</span>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Membership;
